import { render, staticRenderFns } from "./aggrid-labarugi.vue?vue&type=template&id=14f20d47&scoped=true"
import script from "./aggrid-labarugi.vue?vue&type=script&lang=js"
export * from "./aggrid-labarugi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f20d47",
  null
  
)

export default component.exports